import request from './request'

export function browse() {
  const url = '/user/browse'
  return request.post(url, {
    type: 'class'
  })
}



// WEBPACK FOOTER //
// ./src/api/browse.js